import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, formValueSelector } from 'redux-form';
import { Container, Button, Form } from 'reactstrap';
import { connect } from 'react-redux';
import Logger from 'util/Logger';
import { Band } from 'components/layout';
import CubDetailsSection from './CubDetailSection';
import { preventEnterSubmit } from 'actions/formActions';
import { useNavigate } from 'react-router-dom';

const propTypes = {
  handleSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  areas: PropTypes.array,
  signature: PropTypes.string
};

const CubForm = (props) => {
  const { handleSubmit, isSubmitting,initialValues  } = props;

  const navigate = useNavigate(); // Use the useNavigate hook for navigation

  return (
    <Form onSubmit={handleSubmit} onKeyPress={preventEnterSubmit}>
      <Band tint>
        <CubDetailsSection selectedCub={initialValues} />
      </Band>
      <Band tint>

      </Band>
      <Container>
        <Button color="primary" className="btn-save" disabled={isSubmitting}>
          Save
        </Button>
      </Container>
    </Form>
  );
};

const selector = formValueSelector('cubForm');

const mapStateToProps = (state) => ({
});

// Define onSubmitFail outside the component
const onSubmitFail = (errors) => {
  console.log('errorsdh',)
  if(errors!=undefined){
  Logger.error(
    'We were unable to save the changes, please review the fields in red and try again.',
    errors,
    'Cub not saved'
  );
}
};

CubForm.propTypes = propTypes;

const WrappedCubForm = reduxForm({
  form: 'cubForm',
  enableReinitialize: true,
  onSubmitFail // Pass the onSubmitFail function here
})(CubForm);

export default connect(mapStateToProps)(WrappedCubForm);
